module.exports = __webpack_public_path__ + "img/yxlxwm.ea4d45ce.png";